// @flow

function getScriptData<T>(id: string): T {
  const scriptBlock = document.querySelector(`script${id}`);

  if (!scriptBlock) {
    throw new Error(`Could not find a ${id} script`);
  }

  let data: T;

  try {
    data = JSON.parse(scriptBlock.textContent || '');
  } catch (e) {
    throw new Error(`Could not parse ${id} script to json`);
  }

  return data;
}

const getComponentFromShell = (tagName: string) => {
  const response = new Promise<string>((resolve, reject) => {
    window.addEventListener('shell.component.load.success', (e) => {
      resolve(e.detail);
    });

    window.addEventListener('shell.component.load.error', (e) => {
      reject(e.detail);
    });

    window.dispatchEvent(
      new CustomEvent('shell.component.load.request', {
        detail: { tagName },
      }),
    );
  });

  return response;
};

export default {
  getScriptData,
  getComponentFromShell,
};
